export var MuiButton = {
    variant: 'contained',
    color: 'primary',
};
//# sourceMappingURL=MuiButton.js.map